// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* .calls-info h2 {
  font-size: 38px;
  display: inline-block;
  vertical-align: top;
} */
.system-info h2[data-v-ba82d94a] {
  font-weight: normal;
  font-size: 18px;
  width: 52%;
  white-space: inherit;
}
.system-info.syetsm-dashboard h2[data-v-ba82d94a] {
  width: calc(100% - 196px);
}
.system-info.syetsm-dashboard .v-card[data-v-ba82d94a] {
  height: 100% !important;
  display: flex;
}
.sys-call-info[data-v-ba82d94a] {
  display: flex;
  position: relative;
  flex-wrap: wrap;
}
.sys-call-info .v-badge[data-v-ba82d94a] {
  position: ABSOLUTE;
  top: 2px;
  right: -6px;
  background-color: #f44336;
  height: 22px;
  width: 22px;
  text-align: CENTER;
  border-radius: 50%;
  z-index: 1;
  font-size: 12px;
  padding: 2px 0px;
}
.sys-call-info > label[data-v-ba82d94a] {
  flex: 2;
  display: flex;
  margin: auto;
}
.sys-call-info > .sys-call-content[data-v-ba82d94a] {
  flex: 6;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
}
.sys-call-info[data-v-ba82d94a] {
  min-height: 57px;
}
.sys-call-content .num[data-v-ba82d94a],
.sys-call-content .time[data-v-ba82d94a] {
  font-size: 30px;
  display: inline-block;
  height: 100%;
  line-height: normal;
  padding: 0px 5px;
}
.syetsm-dashboard.system-info h2[data-v-ba82d94a] {
  display: inline-block;
}
.syetsm-dashboard.system-info .day-counts-section[data-v-ba82d94a] {
  display: inline-block;
  padding-top: 5px;
  padding-right: 5px;
  vertical-align: top;
}
.syetsm-dashboard.system-info .day-counts-section > span[data-v-ba82d94a] {
  height: 35px;
  width: 60px;
  display: inline-block;
  padding: 7px 0px;
  margin: 0px 2px;
}
.syetsm-dashboard.system-info .day-counts-section > span[data-v-ba82d94a]:last-child {
  margin-right: 0px;
}
.syetsm-dashboard.system-info .day-counts-section .count[data-v-ba82d94a] {
  font-size: 16px;
  margin-left: 5px;
  font-weight: 600;
}
.syetsm-dashboard.system-info .day-counts-section .v-icon[data-v-ba82d94a] {
  font-size: 15px;
  line-height: 1.4;
  position: relative;
  top: 1px;
}
.syetsm-dashboard.system-info .v-card__text[data-v-ba82d94a] {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
}
.customColor[data-v-ba82d94a] {
  display: inline-block;
  background-color: hsla(0, 0%, 100%, 0.1);
}
.customColors[data-v-ba82d94a] {
  background-color: hsla(0, 0%, 100%, 0.2);
}
.syetsm-dashboard-colum[data-v-ba82d94a] .v-icon,
.card-small-tile[data-v-ba82d94a] .v-icon {
  vertical-align: middle;
}
.card-small-tile[data-v-ba82d94a] .v-icon {
  vertical-align: middle;
}
@media only screen and (max-width: 1683px) {
.m-supvr-rcol .system-info.syetsm-dashboard h2[data-v-ba82d94a] {
    display: block !important;
    width: 100% !important;
}
.m-supvr-rcol .syetsm-dashboard.system-info .day-counts-section[data-v-ba82d94a] {
    padding-left: 5px;
}
.m-supvr-rcol .sys-call-info > .sys-call-content[data-v-ba82d94a] {
    justify-content: flex-start;
}
}
@media only screen and (max-width: 1263px) {
.m-supvr-rcol .system-info.syetsm-dashboard h2[data-v-ba82d94a] {
    display: inline-block !important;
    width: calc(100% - 210px) !important;
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
